/**
 * Created by Administrator on 2019/07/03 0030.
 * 所有自定义全局组件在此引入
 */
import Vue from 'vue';
import promptMessages from '@/components/messages';
Vue.use(promptMessages); // 表头提示自定义提示信息组件
